import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  page: {
    backgroundColor: '#F8F9FE',
    padding: { xs: '24px 16px 52px', md: '42px 32px 72px' },
  },
  layout: {
    maxWidth: '1200px',
    margin: 'auto',
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', lg: 'minmax(0, 2fr) minmax(280px, 1fr)' },
    gap: { xs: '26px', lg: '32px' },
    alignItems: 'start',
  },
  main: { display: 'flex', flexDirection: 'column', gap: '26px', minWidth: 0 },
  featuredImageWrapper: {
    width: '100%',
    aspectRatio: { xs: '16 / 10', md: '16 / 8' },
    overflow: 'hidden',
    borderRadius: '16px',
    backgroundColor: '#EEF0F6',
    border: '1px solid #E6E8F2',
    boxShadow: '0 8px 24px rgba(31,34,51,.05)',
  },
  featuredImage: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  toc: {
    backgroundColor: 'common.white',
    border: '1px solid #E6E8F2',
    borderRadius: '16px',
    padding: { xs: '18px', md: '22px' },
    boxShadow: '0 8px 24px rgba(31,34,51,.05)',
  },
  tocTitle: { color: '#1F2233', fontSize: '19px', fontWeight: '700' },
  tocSubtitle: { color: '#6B7085', fontSize: '12px', marginTop: '3px' },
  tocList: {
    margin: '14px 0 0',
    paddingLeft: '22px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  tocItem: { color: 'primary.main', padding: '3px 0' },
  tocLink: {
    color: 'primary.main',
    fontSize: '14px',
    fontWeight: '500',
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
  },
  article: {
    backgroundColor: 'common.white',
    border: '1px solid #E6E8F2',
    borderRadius: '16px',
    padding: { xs: '20px', md: '34px' },
    boxShadow: '0 8px 24px rgba(31,34,51,.05)',
  },
  articleBody: {
    maxWidth: 'none',
    margin: 0,
    padding: 0,
    color: '#45495B',
    fontSize: { xs: '15px', md: '16px' },
    lineHeight: 1.65,
    '& h2': {
      color: '#1F2233',
      fontSize: { xs: '21px', md: '26px' },
      lineHeight: 1.3,
      margin: '24px 0 9px !important',
      scrollMarginTop: '130px',
    },
    '& h3': {
      color: '#1F2233',
      fontSize: { xs: '18px', md: '21px' },
      margin: '20px 0 8px !important',
    },
    '& p': { margin: '0 0 12px !important' },
    '& p:empty': { display: 'none' },
    '& ul, & ol': {
      margin: '0 0 14px !important',
      paddingLeft: '24px',
    },
    '& li': { marginBottom: '5px' },
    '& li > p': { marginBottom: '5px !important' },
    '& br + br': { display: 'none' },
    '& img': {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: '14px',
      margin: '14px auto',
    },
    '& a': { color: 'primary.main' },
  },
  related: {
    backgroundColor: '#FAF2F5',
    border: '1px solid #E8CBD8',
    borderRadius: '16px',
    padding: '22px',
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'stretch', sm: 'center' },
    gap: '18px',
  },
  relatedTitle: { color: '#1F2233', fontSize: '20px', fontWeight: '700' },
  relatedText: { color: '#6B7085', fontSize: '13px', marginTop: '4px' },
  relatedAction: {
    display: 'block',
    color: 'common.white',
    backgroundColor: 'primary.main',
    padding: '10px 16px',
    borderRadius: '9px',
    fontWeight: '600',
    fontSize: '13px',
    textAlign: 'center',
  },
  sidebar: {
    position: { xs: 'static', lg: 'sticky' },
    top: '118px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  categoryPanel: {
    backgroundColor: 'common.white',
    border: '1px solid #E6E8F2',
    borderRadius: '14px',
    overflow: 'hidden',
  },
  categoryHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
    padding: '14px 16px',
    background: 'linear-gradient(110deg, #8D174C, #48132A)',
    border: 0,
    width: '100%',
    cursor: 'pointer',
    textAlign: 'left',
  },
  categoryHeaderTitle: {
    color: 'common.white',
    fontSize: '14px',
    fontWeight: '800',
  },
  categoryCount: {
    color: 'common.white',
    backgroundColor: 'rgba(255,255,255,.18)',
    padding: '3px 8px',
    borderRadius: '999px',
    fontSize: '9px',
    fontWeight: '700',
  },
  categoryHeaderMeta: { display: 'flex', alignItems: 'center', gap: '10px' },
  categoryChevron: {
    color: 'common.white',
    fontSize: '20px',
    lineHeight: 1,
    transform: 'rotate(0deg)',
    transition: 'transform .2s ease',
  },
  categoryChevronOpen: { transform: 'rotate(180deg)' },
  categoryLinks: { padding: '8px 12px 12px' },
  categoryItem: { borderBottom: '1px solid #F0F1F6' },
  categoryLink: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#45495B',
    fontSize: '12px',
    fontWeight: '600',
    padding: '9px 8px',
    width: '100%',
    border: 0,
    background: 'none',
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': { color: 'primary.main', backgroundColor: '#FAF2F5' },
  },
  itemChevron: {
    fontSize: '18px',
    lineHeight: 1,
    transition: 'transform .2s ease',
  },
  itemChevronOpen: { transform: 'rotate(90deg)' },
  categorySubLinks: {
    padding: '2px 8px 9px 18px',
    borderLeft: '2px solid #E8CBD8',
    margin: '0 8px 8px',
  },
  categorySubLink: {
    color: '#64687A',
    fontSize: '11px',
    padding: '6px 8px',
    borderRadius: '6px',
    '&:hover': { color: 'primary.main', backgroundColor: '#FAF2F5' },
  },
  relatedSideLink: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#45495B',
    fontSize: '12px',
    fontWeight: '600',
    padding: '7px 0',
    '&:hover': { color: 'primary.main' },
  },
  callback: {
    borderRadius: '16px',
    padding: '22px',
    background: 'linear-gradient(145deg, #48132A, #8D174C)',
    color: 'common.white',
  },
  callbackLabel: {
    color: '#F6CBDD',
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '1px',
  },
  callbackTitle: { fontSize: '22px', fontWeight: '700', marginTop: '4px' },
  callbackText: { color: '#F7DCE8', fontSize: '13px', margin: '8px 0 18px' },
  callbackButton: {
    display: 'block',
    backgroundColor: 'common.white',
    color: 'primary.main',
    padding: '11px 14px',
    borderRadius: '9px',
    textAlign: 'center',
    textDecoration: 'none',
    fontSize: '13px',
    fontWeight: '700',
    border: 0,
    cursor: 'pointer',
  },
  sidePanel: {
    backgroundColor: 'common.white',
    border: '1px solid #E6E8F2',
    borderRadius: '14px',
    padding: '18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  sideTitle: {
    color: '#1F2233',
    fontSize: '16px',
    fontWeight: '700',
    paddingBottom: '9px',
    borderBottom: '1px solid #E6E8F2',
  },
  sideLink: {
    color: 'primary.main',
    fontSize: '13px',
    '&:hover': { textDecoration: 'underline' },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles
